import React, { useEffect } from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import FAQsMain from '../../components/FAQs/FAQsMain';


const FAQs = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ - Quality Indicators Frequently Asked Questions`;
      });
    return (<>
            <FAQsMain/>

    </>
    )
}

export default FAQs;